module.exports = __webpack_public_path__ + "static/media/nethronix.09a33151.svg";